import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { InvTrndismp } from "../invinterfaces/invtrndismp";
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class TrnpordismpService {
  public way: string;
  private _distribucionmp: InvTrndismp[];

  get distribucionmp(): InvTrndismp[] {
    return this._distribucionmp;
  }

  set distribucionmp(value: InvTrndismp[]) {
    this._distribucionmp = value;
  }
  public total = 0
  public decimalesTotalEnt=2
  constructor(private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService
  ) {
    this.way = sessionStorage.getItem('way');
  }
  getdetdistribucion( ordpro) {
    return this.http.post<any[]>(this.way + '/inventario/trndistrimp/20eeb5dd6cb9de0000', {
      elementos: {
       
        p_encordpro_numero: ordpro,
        
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  calcular(intCol, distrimpSelected){
    let intIndiceFila=0

  }
}
